class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.section;
    const delay = parseInt(`${this.dataset.delay}000`);
    const frequency = parseInt(this.dataset.frequency);
    this.date = this.dataset.timer;
    let show = false;
    
    if (localStorage.getItem('fibo-newsletter') === '' || localStorage.getItem('fibo-newsletter') === null || localStorage.getItem('fibo-newsletter') === undefined) {
      show = true;
    } else {
      let checkTime = new Date(this.date) - new Date(localStorage.getItem('fibo-newsletter'));
      const tamp = checkTime % 1000;
      checkTime = (checkTime - tamp) / 1000;
      const days = Math.floor(checkTime / 86400);
      if (days >= frequency) {
        show = true;
      }
    }
    
    if (show) {
      setTimeout(() => {
        this.show();
      }, delay);
    }
  }
  
  show() {
    document.querySelector('html').classList.add('newsletter-open');
    document.body.classList.add('newsletter-open');
    this.classList.add('modal-open');
    this.close();
  }
  
  close() {
    window.onkeyup = (event) => {
      if(event.code.toUpperCase() === 'ESCAPE') this.onButtonClick(event)
    }
    
    this.querySelectorAll('[data-modal-close]').forEach(
      (action) => {
        action.addEventListener('click', this.onButtonClick.bind(this));
      }
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    
    localStorage.setItem('fibo-newsletter', this.date);
    document.querySelector('html').classList.remove('newsletter-open');
    document.body.classList.remove('newsletter-open');
    this.classList.remove('modal-open');
  }
}

customElements.define('newsletter-popup', NewsletterPopup);